export const enum TINY_SELECT_STRATEGY_TYPE{
    ONLY_SELECT = 100
}